import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyers } from '../data/buyers';
import { OFFER_ANCHOR, PRODUCT } from '../data/constants';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: number;
    const showTimer = window.setTimeout(() => setVisible(true), 4000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      timeout = window.setTimeout(() => {
        setIndex(i => (i + 1) % buyers.length);
        setVisible(true);
      }, 700);
    }, 11000);
    return () => {
      window.clearTimeout(showTimer);
      window.clearInterval(cycle);
      window.clearTimeout(timeout);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <AnimatePresence data-id="element-157" data-mp="1gx2tu7contvi">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      x: -24,
      scale: 0.97
    }} animate={{
      opacity: 1,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      x: -24,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-3 left-3 z-50 w-[270px] max-w-[calc(100vw-24px)] sm:bottom-5 sm:left-5 sm:w-[310px]" role="status" aria-live="polite" data-id="element-158" data-mp="164xrf6byp4os">
          <div className="relative rounded-lg border-2 border-mod-yellow bg-panel2 p-3 pr-7 shadow-[0_0_0_3px_rgba(242,118,11,0.4),0_16px_32px_-12px_rgba(0,0,0,0.9)]" data-id="element-159" data-mp="n7dcaqz01khd">
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-1.5 top-1.5 rounded p-1 text-metal transition-colors duration-150 ease-out hover:text-white" data-id="element-160" data-mp="x6c8vb6hppo0">
              <XIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-161" data-mp="23m6asfmngtbo" />
            </button>
            <a href={OFFER_ANCHOR} className="flex items-start gap-2.5" data-id="element-162" data-mp="2ap2yx4lqeg8j">
              <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-mod-green" strokeWidth={2.5} data-id="element-163" data-mp="2aqxowxbv0yjh" />
              <div className="min-w-0" data-id="element-164" data-mp="2knsg0v5szwnq">
                <p className="font-display text-[13px] uppercase leading-tight text-white" data-id="element-165" data-mp="2kkwktelcbm2z">
                  {buyer.name} {buyer.flag} just purchased
                </p>
                <p className="mt-0.5 truncate text-[11px] font-semibold uppercase tracking-wide text-brandorange" data-id="element-166" data-mp="1rzmwucueefq0">
                  {PRODUCT}
                </p>
                <p className="mt-0.5 text-[10.5px] font-medium text-metal" data-id="element-167" data-mp="21vpxfe9lq6au">
                  {buyer.city}, {buyer.country} · a few minutes ago
                </p>
              </div>
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}